<template>
  <div @click="open = false">
    <div class="content">
      <div class="headBox">
        <div class="img" @click="uploadFile">
          <img :src="$imgUrl + avatars" alt="" />
        </div>
        <div class="box">
          <div class="name">上传头像</div>
          <div class="txt">数据表明招聘者对真实头像更有好感</div>
        </div>
      </div>
      <div class="cont">
        <div class="box">
          <div class="name"><span class="red">* </span>真实姓名</div>
          <div class="inpBox inpBoxXuan">
            <input type="text" v-model="realname" placeholder="请输入" />
          </div>
        </div>
        <div class="box">
          <div class="name"><span class="red">* </span>身份证号码</div>
          <div class="inpBox inpBoxXuan">
            <input type="text" v-model="idcard" placeholder="请输入" />
          </div>
          <!-- <div class="txt">注：和公安******（待补充）</div> -->
        </div>
        <div class="box">
          <div class="name">籍贯</div>
          <div class="inpBox inpBoxXuan">
            <input type="text" v-model="residence" placeholder="请输入" />
          </div>
        </div>
        <div class="box">
          <div class="name">手机号码</div>
          <div class="inpBox disunInp">
            <input type="text" v-model="phone" disabled placeholder="请填写手机号码" />
            <div class="xiugai dis-cent" @click="xiugaiPhone">修改</div>
          </div>
        </div>
        <div class="box">
          <div class="name">邮箱</div>
          <div class="inpBox inpBoxXuan">
            <input type="text" v-model="email" mode="month" placeholder="请填写邮箱" />
          </div>
        </div>
        <div class="box">
          <div class="name">微信号</div>
          <div class="inpBox inpBoxXuan">
            <input type="text" v-model="weixin" mode="month" placeholder="请填写微信号" />
          </div>
        </div>
      </div>
      <div class="tcBom">
        <div class="qbtn dis-cent" @click="delClick">取消</div>
        <div class="btn dis-cent" @click="qrClick">确定</div>
      </div>
    </div>
    <input type="file" ref="fileInput" accept="image/*" @change="onFileChange" style="display: none" />
  </div>
</template>

<script>
import {
  Select,
  Menu,
  Form,
  Input,
  Dropdown,
  Upload,
  Icon,
  DatePicker,
  LocaleProvider,
} from "ant-design-vue";
export default {
  components: {
    "a-select": Select,
    "a-select-option": Select.Option,
    "a-menu": Menu,
    "a-menu-item": Menu.Item,
    "a-sub-menu": Menu.SubMenu,
    "a-form": Form,
    "a-form-item": Form.Item,
    "a-input": Input,
    "a-dropdown": Dropdown,
    "a-textarea": Input.TextArea,
    "a-upload": Upload,
    "a-icon": Icon,
    "a-range-picker": DatePicker.RangePicker,
    "a-month-picker": DatePicker.MonthPicker,
    "locale-provider": LocaleProvider,
    "a-date-picker": DatePicker,
  },
  name: "",
  data() {
    return {
      xbOn: 0,
      xbList: ["男", "女"],
      sfKey: "请选择", //身份
      dzKey: "请选择", //期望工作地址
      zzKey: "请选择", //学历
      ztKey: "请选择", //目前状态
      startMonth: "",
      work_time: "",
      areaTxt: "请选择",
      areaId: "",
      areaList: [
        {
          id: 1146,
          pid: 1142,
          code: 331021,
          name: "不限",
          car: "",
          is_sent: 1,
          is_delete: 0,
        },
        {
          id: 3723,
          pid: 1146,
          code: 0,
          name: "玉城",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
        },
        {
          id: 3724,
          pid: 1146,
          code: 0,
          name: "坎门",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
        },
        {
          id: 3725,
          pid: 1146,
          code: 0,
          name: "大麦屿",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
        },
        {
          id: 3726,
          pid: 1146,
          code: 0,
          name: "楚门",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
        },
        {
          id: 3727,
          pid: 1146,
          code: 0,
          name: "清港",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
        },
        {
          id: 3728,
          pid: 1146,
          code: 0,
          name: "龙溪",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
        },
        {
          id: 3729,
          pid: 1146,
          code: 0,
          name: "芦浦",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
        },
        {
          id: 3730,
          pid: 1146,
          code: 0,
          name: "沙门",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
        },
        {
          id: 3731,
          pid: 1146,
          code: 0,
          name: "干江",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
        },
        {
          id: 3732,
          pid: 1146,
          code: 0,
          name: "鸡山",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
        },
        {
          id: 3733,
          pid: 1146,
          code: 0,
          name: "海山",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
        },
      ],
      typeData: {
        期望工作地址: "",
        目前状态: "",
      },
      currentTxt: "",
      currentId: "",
      current: [],
      open: false,
      avatars: "",
      realname: "",
      idcard: "",
      residence: "",
      phone: "",
      email: "",
      weixin: "",
      speciality: "",
    };
  },
  props: {
    info: { type: Object, default: {} },
  },
  created() {
    console.log(this.info);
    this.avatars = this.info.member.avatars;
    this.realname = this.info.memberinfo.realname;
    this.currentTxt = this.info.memberinfo.current_cn;
    this.currentId = this.info.memberinfo.current;
    this.xbOn = this.info.memberinfo.sex == 2 ? 1 : 0;
    this.idcard = this.info.memberinfo.idcard;
    this.residence = this.info.memberinfo.residence;
    this.startMonth = this.info.memberinfo.birthday;
    this.work_time = this.info.memberinfo.work_time;
    this.phone = this.info.memberinfo.phone;
    this.email = this.info.memberinfo.email;
    this.weixin = this.info.memberinfo.weixin;
    this.speciality = this.info.memberinfo.speciality;
    let category_gets = window.localStorage.getItem("category_gets");
    if (category_gets) {
      this.category_gets = JSON.parse(category_gets);
      this.typeHcGet(this.category_gets);
    } else {
      this.typeGet();
    }
  },
  methods: {
    uploadFile() {
      this.$refs.fileInput.click();
    },
    onFileChange(e) {
      if (!e.target.files) {
        return;
      }
      var formData = new FormData();
      formData.append("file", e.target.files[0]);
      formData.append("where", "product");
      this.$uploadfile("/common/fileupload", formData).then((res) => {
        if (res.data.status) {
          this.avatars = res.data.data.path_name;
        } else {
          this.$message.error("网络繁忙,请稍后再试~");
        }
      });
    },
    openClick() {
      this.open = true;
    },
    onPanelChange(e) {
      console.log(e._d);
      this.startMonth = this.$moment(e._d).format("YYYY");
      this.open = false;
    },
    jobChange(e) {
      this.work_time = this.$moment(e._d).format("YYYY-MM");
      console.log(this.work_time);
    },
    typeGet() {
      this.$get("/common/category_gets", {
        pageNo: -1,
      }).then((res) => {
        window.localStorage.setItem("category_gets", JSON.stringify(res.data));
        this.typeHcGet(res.data);
      });
    },
    typeHcGet(data) {
      // 所属行业
      let current = [];
      for (let i = 0; i < data.length; i++) {
        const e = data[i];
        e.select = false;
        if (e.c_alias == "QS_current") {
          current.push(e);
        }
      }
      this.current = current;
    },
    hyClick(e) {
      let key = e.key.split("_");
      let data = {
        type: key[0],
        id: key[1],
        name: key[2],
      };
      this.typeData[key[0]] = e.key;
      if (key[0] == "期望工作地址") {
        this.areaTxt = data.name;
        this.areaId = data.id;
      }
      if (key[0] == "目前状态") {
        this.currentTxt = data.name;
        this.currentId = data.id;
      }
    },
    xiugaiPhone() {
      // this.$router.push({
      //   path: "/phone",
      // });
      window.open("#/phone");
    },
    stardisabledDate(current) {
      const today = new Date();
      return (
        current &&
        current.year() === today.getFullYear() &&
        current.month() > today.getMonth()
      );
    },
    sfClick(e) {
      this.sfKey = e.key;
    },
    dzClick(e) {
      this.dzKey = e.key;
    },
    zzClick(e) {
      this.zzKey = e.key;
    },
    ztClick(e) {
      this.ztKey = e.key;
    },
    qrClick() {
      let data = {
        ...this.info.memberinfo,
      };
      data.realname = this.realname; // 名字
      data.idcard = this.idcard; //身份证
      data.residence = this.residence; //籍贯
      data.email = this.email; //邮箱
      data.current = Number(this.currentId); // 状态
      data.current_cn = this.currentTxt;
      data.weixin = this.weixin; //微信
      data.birthday = this.startMonth; // 出生
      data.sex_cn = this.xbOn == 0 ? "男" : "女"; //性别
      data.sex = this.xbOn == 0 ? 1 : 2;
      data.speciality = this.speciality;
      data.work_time = this.work_time;
      if (!data.realname) {
        this.$message.error("请填写姓名");
        return;
      }
      if (!data.idcard) {
        this.$message.error("请填写身份证号码");
        return;
      }
      data = JSON.stringify(data);
      this.$post("/nozzle/web/member_info_save", {
        avatars: this.avatars,
        data: data,
      }).then((res) => {
        console.log(res);
        if (res.data.status == 1) {
          this.$message.success("修改成功");
          this.$emit("show", 1);
        }
      });
    },
    delClick() {
      this.$emit("show");
    },
    xbClick(i) {
      this.xbOn = i;
    },
  },
  mounted() { },
  computed: {},
};
</script>
<style lang="less" scoped>
/deep/.ant-input {
  height: 44px !important;
  border-radius: 10px;
  width: 100%;
  color: #000;
}

/deep/.ant-calendar-picker {
  width: 100%;
}

/deep/.ant-calendar-range-picker-separator {
  position: relative;
  top: 6px;
}

.content {
  background-color: #f1f5fc;
  padding: 20px 50px;
  margin-bottom: 10px;
  margin-top: 20px;

  .headBox {
    display: flex;
    align-items: center;

    .img {
      width: 70px;
      height: 70px;
      border-radius: 50%;
      cursor: pointer;
    }

    .box {
      padding-left: 20px;
      width: calc(100% - 70px);
      box-sizing: border-box;

      .name {
        font-weight: 500;
        font-size: 22px;
        color: #147ee0;
      }

      .txt {
        color: #8b8b8b;
        margin-top: 10px;
      }
    }
  }

  .cont {
    padding-top: 20px;
    display: flex;
    flex-wrap: wrap;

    .baoguo {
      display: flex;
      width: 100%;
    }

    .box {
      width: calc(50% - 30px);
      margin-right: 60px;
      margin-bottom: 20px;

      .selectBox {
        margin-top: 10px;
        width: 100%;
        border-radius: 10px;
        border: 1px solid #d8d8d8;
        background-color: #fff;
        padding: 2px;
        padding-bottom: 0;
        box-sizing: border-box;
        display: flex;
        cursor: pointer;

        .contBox {
          width: calc(100% - 50px);
          display: flex;
          flex-wrap: wrap;

          .text {
            height: 38px;
            display: flex;
            align-items: center;
            padding-left: 15px;
            color: #9c9c9c;
            margin-bottom: 2px;
          }

          .hei {
            color: #000;
          }

          .li {
            background-color: #e2e4ec;
            border-radius: 10px;
            height: 38px;
            padding: 0 6px 0 10px;
            margin-right: 2px;
            margin-bottom: 2px;
            color: #000;

            .iconfont {
              position: relative;
              top: 1px;
              font-size: 14px;
              margin-left: 5px;
              cursor: pointer;
            }
          }
        }

        .barrage {
          width: 50px;
          font-size: 25px;
          cursor: pointer;
          color: #9c9c9c;
        }
      }

      .selectBox:hover {
        border: 1px solid #147ee0;

        .contBox {
          .text {
            color: #147ee0;
          }
        }
      }

      .inpBox {
        margin-top: 10px;
        width: 100%;
        border-radius: 10px;
        border: 1px solid #d8d8d8;
        background-color: #fff;
        padding: 2px;
        padding-bottom: 0;
        box-sizing: border-box;
        display: flex;
        cursor: pointer;
        position: relative;

        input {
          height: 38px;
          padding: 0 15px;
          width: 100%;
          box-sizing: border-box;
        }
      }

      .txt {
        margin-top: 10px;
        color: #888;
        font-size: 12px;
      }

      .disunInp {
        background-color: #f3f3f3;

        .xiugai {
          position: absolute;
          top: 0;
          right: 0;
          width: 60px;
          height: 100%;
          color: #f51515;
        }
      }

      .inpBoxXuan:hover {
        border: 1px solid #147ee0;
      }

      .xinzi {
        height: 44px;
        margin-top: 10px;
        display: flex;
        align-items: center;

        .numBox {
          width: 110px;
          height: 44px;
          border-radius: 10px;
          border: 1px solid #d8d8d8;
          background-color: #fff;
          box-sizing: border-box;
          padding: 0 15px;

          input {
            width: 100%;
            height: 100%;
            box-sizing: border-box;
          }
        }

        .text {
          width: 60px;
        }
      }

      .xinbie {
        height: 44px;
        margin-top: 10px;
        display: flex;

        .text {
          height: 100%;
          width: calc(50% - 10px);
          margin-right: 20px;
          border-radius: 5px;
          box-sizing: border-box;
          border: 1px solid #d8d8d8;
          background-color: #fff;
          color: #9c9c9c;
          cursor: pointer;
        }

        .on {
          border: 1px solid #147ee0;
          background-color: #f4faff;
          color: #147ee0;
        }

        .text:last-child {
          margin-right: 0;
        }
      }

      .xuanCont {
        display: flex;
        align-items: center;
        margin-top: 10px;

        .xuanBox {
          box-sizing: border-box;
          background-color: #fff;
          width: 150px;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        .jian {
          margin: 0 12px;
          font-size: 18px;
        }
      }
    }

    .box:nth-child(2n) {
      margin-right: 0;
    }

    .quanBox {
      width: 100%;
      margin-right: 0;
      margin-bottom: 20px;

      .areaBox {
        border: 1px solid #d8d8d8;
        height: 200px;
        background-color: #fff;
        border-radius: 10px;
        margin-top: 15px;
        overflow: hidden;
        padding: 15px;
        box-sizing: border-box;

        textarea {
          width: 100%;
          height: 100%;
          border: none;
        }
      }
    }
  }

  .tcBom {
    display: flex;
    align-items: center;
    justify-content: flex-end;

    .btn {
      width: 90px;
      border-radius: 5px;
      height: 40px;
      background-color: #147ee0;
      color: #fff;
      cursor: pointer;
    }

    .qbtn {
      cursor: pointer;
      width: 90px;
      border-radius: 5px;
      height: 40px;
      box-sizing: border-box;
      border: 1px solid #147ee0;
      color: #147ee0;
      margin-right: 20px;
    }
  }
}
</style>
